import apiClient from './api'

export default {
    async getAll (params = {}) {
        params.paginate = false
        return await apiClient.get('/cms/roles', { params })
    }
}